module.exports = __webpack_public_path__ + "527573614efd62cc0dbc2db676b33a3b.png";